import {
  ENVIRONMENT_INITIALIZER,
  EnvironmentProviders,
  inject,
  Provider,
} from "@angular/core";
import { SettingsService } from "./settings.service";

export const provideSettings = (): Array<Provider | EnvironmentProviders> => {
  return [
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(SettingsService),
      multi: true,
    },
  ];
};
